import { create } from "zustand";
import { immer } from "zustand/middleware/immer";
import type { IGetReceiptParkingListResponse } from "../apis/parking/type";
import type { IInquireFormValues } from "../pages/receiptList/inquireForm";

type TReceiptStore = {
  receiptParkingList: IGetReceiptParkingListResponse[];
  setReceiptParkingList: (
    receiptParkingList: IGetReceiptParkingListResponse[]
  ) => void;
  selectedId: number;
  setSelectedId: (id: number) => void;
  receiptFormData: IInquireFormValues | null;
  setReceiptFormData: (data: IInquireFormValues) => void;
  clearOtp: () => void;
};

const initState = {
  receiptParkingList: [],
  selectedId: 0,
  receiptFormData: null,
};

const useReceiptStore = create<TReceiptStore>()(
  immer((set) => ({
    ...initState,
    setReceiptParkingList(receiptParkingList) {
      set((state) => ({ ...state, receiptParkingList: receiptParkingList }));
    },
    setSelectedId(id: number) {
      set((state) => ({
        ...state,
        selectedId: id,
      }));
    },
    setReceiptFormData(data: IInquireFormValues) {
      set((state) => ({
        ...state,
        receiptFormData: data,
      }));
    },
    clearOtp() {
      set((state) => ({
        ...state,
        receiptFormData: state.receiptFormData
          ? { ...state.receiptFormData, otp: "" }
          : null,
      }));
    },
  }))
);

export default useReceiptStore;
